import React, { FC, useMemo } from 'react';
import { useExperiments } from '@wix/fe-essentials-standalone';
import { useTemplatesContext } from '@components/Contexts/TemplatesContext';
import { SHOULD_SUPPORT_HINDI_SPEC } from '@utils/constants';
import { LANGUAGES_WITHOUT_ALL } from '@common/types';
import MultiSelectionFilter from '@components/Templates/FilterPanel/MultiSelectionFilter';

type Props = {};

const LanguagesFilter: FC<Props> = ({}) => {
  const { experiments } = useExperiments({ readOnly: true });
  const shouldSupportHindi = experiments.enabled(SHOULD_SUPPORT_HINDI_SPEC);
  const {
    state: { filters },
  } = useTemplatesContext();

  const languages = useMemo(() => {
    const entries = Object.entries(LANGUAGES_WITHOUT_ALL).filter(
      ([key]) => key !== 'HINDI' || shouldSupportHindi,
    );
    return Object.freeze(Object.fromEntries(entries));
  }, [shouldSupportHindi]);

  return (
    <MultiSelectionFilter
      selectedValue={filters.languages}
      items={languages}
      langTokenPrefix={'marketplace.templates-page.language-'}
      updatedQueryParam={'languages'}
      dataHook={'languages'}
      type={'languages'}
    />
  );
};

export default LanguagesFilter;
